<template>
  <div class="wrap" v-loading="allLoading">
    <div class="main-wrap my-orders">
       <div class="top-area" ref="topBox">
        <div class="order-navigation">
          <a
            class="text1"
            href="/#/catalogue"
          >{{L.home}}</a>
          <span class="line">/</span>
          <!-- 我的订单 -->
          <a
            class="text2"
            href="/#/myOrders" 
          >{{L.myOrder}}</a>
        </div>
        <div class="my-orders-title">
          <span class="title-text">{{L.myOrder}}</span>
        </div>
       </div>
      <!-- 搜索 -->
      <div class="search-wrap">
        <el-form :model="search" ref="formSearch" :rules="rules" :show-message="false">
          <div class="square small-length">
            <!-- 订购日期从 -->
            <span class="text">{{L.orderDateFrom}}: </span>
            <el-form-item prop="dateFrom">
              <el-date-picker
                size="mini"
                class="search-field small-length"
                v-model="search.dateFrom"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                :picker-options="pickerOptions"
                type="date">
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="square small-length">
            <!-- 订购日期到 -->
            <span class="text">{{L.orderDateTo}}: </span>
            <el-form-item prop="dateTo">
              <el-date-picker
                size="mini"
                class="search-field small-length"
                v-model="search.dateTo"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                :picker-options="pickerOptions"
                type="date">
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="square">
            <!-- EBS订单编号 -->
            <!-- <span class="text">{{L.orderID}}:</span> -->
            <span class="text">{{L.orderID}}:</span>
            <el-form-item prop="ebsorderNo">
              <el-input size="mini" @keyup.enter.native="getOrderList" v-model="search.ebsorderNo" class="search-field"></el-input>
            </el-form-item>
          </div>
          <div class="square">
            <!-- 采购订单编号 -->
            <span class="text">{{L.PONumber}}:</span>
            <el-form-item prop="poreference">
              <el-input size="mini" @keyup.enter.native="getOrderList" v-model="search.poreference" class="search-field"></el-input>
            </el-form-item>
          </div>
          <div class="square long-length">
            <!-- 物料号 -->
            <span class="text">{{L.articleNumber}}:</span>
            <el-form-item prop="articleNumber">
              <el-input size="mini" @keyup.enter.native="getOrderList" v-model="search.articleNumber" class="search-field long-length"></el-input>
            </el-form-item>
          </div>
          <!-- 订单状态-选择框 -->
          <div class="square order-status">
            <!-- 订单状态 -->
            <span class="text">{{L.orderStatus}}:</span>
            <div class="select-status" @mouseleave="mouseleave(1)">
              <el-form-item prop="orderStatus">
                <!-- 订单状态-input框 -->
                <div class="inp-wrap" @click="clickChooseStatus">
                  <div class="left-text">{{orderStatusText}}</div>
                  <div class="arrow">
                    <span class="iconfont icon_arrow" :class="{'active-arrow':show.showChoose}">&#xeb8b;</span>
                  </div>
                </div>
              </el-form-item>
              <!-- 弹框 -->
              <transition
                  @enter="enter"
                  @afterEnter="afterEnter"
                  @leave="leave"
                  @afterLeave="afterLeave"
                >
                  <div class="choose-big" v-show="show.showChoose">
                    <span class="triangle"></span>
                    <div class="choose-wrap">
                      <div class="choose" @click="chooseStatus(item,i)" v-for="item,i in orderStatusArr" :key="item.statusCode">
                        <div class="line1" :class="{'active-color':item.showTick}">{{item.statusValue}}</div>
                        <span class="iconfont icon_tick" v-show="item.showTick">&#xe8e6;</span>
                      </div>
                    </div>
                  </div>
              </transition>
            </div>
          </div>
          <div class="square">
            <!-- 发货至 -->
            <span class="text">{{L.shipTo}}:</span>
            <el-form-item prop="shipTo">
              <el-select size="mini" v-model="search.shipTo" class="search-field" placeholder="">
                <el-option
                  v-for="item in shipToArr"
                  :key="item.siteUseLocation"
                  :label="item.siteUseLocation"
                  :value="item.siteUseLocation">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <!-- 按钮 -->
      <div class="btn-wrap" ref="btnBox">
        <div class="left">
          <template v-if="$store.state.userInfo && $store.state.userInfo.customerAccountNo">
            <!-- 订单概述 (xlsx) -->
            <div class="btn-with-bg no-left-width" @click="downloadList">{{L.orderOoverview}}</div>
            <!-- 订单详情 (xlsx) -->
            <div class="btn-with-bg" @click="downloadDetail">{{L.orderDetails}}</div>
          </template>
          <template v-if="$store.state.userInfo && $store.state.userInfo.ledCustomerAccountNo">
            <!-- 订单概述 (xlsx) -->
            <div class="btn-with-bg no-left-width" @click="downloadListLed">{{L.orderOoverviewLed}}</div>
            <!-- 订单详情 (xlsx) -->
            <div class="btn-with-bg" @click="downloadDetailLed">{{L.orderDetailsLed}}</div>
          </template>
        </div>
        <div class="right">
          <!-- 清除过滤 -->
          <div class="btn-no-bg" @click="handleClearFilters">{{L.cleaFilters}}</div>
          <!-- 显示未关闭订单 -->
          <div class="btn-no-bg" @click="showOpenOrders">{{L.showOpenOrders}}</div>
          <!-- 搜索 -->
          <div class="btn-with-bg" @click="getOrderList">{{L.search}}</div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="table-wrap">
        <el-table
          v-if="tableReady"
          ref="orderTable"
          class="cqm-table"
          :height="tableHeight"
          highlight-current-row
          size="mini"
          :data="orderList"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            type="index"
            label=""
            width="50">
          </el-table-column>
          <el-table-column
            :min-width="140"
            prop="ebsorderNo"
            :sortable="true"
            :label="tableLable.orderID">
              <template slot-scope="scope">
                <a 
                  :href="orderDetailLink(scope.row)"
                  class="order-id"
                >{{scope.row.ebsorderNo}}</a>
              </template>
          </el-table-column>
          <el-table-column
            prop="poreference"
            sortable
            :label="tableLable.PONumber">
          </el-table-column>
          <el-table-column
            prop="orderDate"
            sortable
            :label="tableLable.orderDate"
          >
            <template slot-scope="scope">
              <span>
                {{ formatDate(scope.row.orderDate.split(' ')[0]) }}
                {{ scope.row.orderDate.split(' ')[1] }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="orderStatus"
            :label="tableLable.orderStatus">
          </el-table-column>
          <el-table-column
            width="140"
            v-if="showTotalAmount"
            prop="totalAmount"
            sortable
            :label="tableLable.orderTotalAmount"
          >
            <template slot-scope="scope">
              <span>{{ formatMoney(scope.row.totalAmount,scope.row.currency) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            v-if="showTotalAmountTax"
            prop="totalAmountWithTax"
            sortable
            :label="tableLable.taxTotalAmount"
          >
            <template slot-scope="scope">
              <span>{{ formatMoney(scope.row.totalAmountWithTax,scope.row.currency) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="130"
            prop="placedVia"
            :label="tableLable.placedVia">
            <template slot-scope="scope">
              <div class="place-via">
                <span>{{ scope.row.placedVia }}</span>
                <el-tooltip
                 v-if="scope.row.placedVia=='Migrated'"
                  class="item" 
                  effect="dark"
                  placement="top"
                >
                <div slot="content">This new EBS order ID contains the open items from your original order that we have migrated to our new system. Items of original order got cancelled accordingly. Sort /search by PO number to see both orders.</div>
                  <span class="iconfont icon-info">&#xed50;</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="shipToInfo"
            width="250"
            :label="tableLable.shipTo">
          </el-table-column>
        </el-table>
      </div>
    </div>
    
    
  </div>
</template>

<script>
import {postAction,downFilePost} from '@/api/tool'
import {api_order_list,api_order_list_download,api_order_list_detail_download,api_order_select_data,api_order_list_download_LED,api_order_list_detail_download_LED} from '@/api/api'
import moment from 'moment'

export default {
  name:'MyOrders',
  data(){
    return {
      show:{
        showChoose:false
      },
      tableHeight:200, //表格固定高度，由 handleResize 动态计算（参考商机列表页 Opportunity/index.vue）
      savedScrollTop:0, //表格内部纵向滚动位置快照（keep-alive 离开时 DOM 摘除会丢失，返回时还原）
      savedScrollLeft:0, //表格内部横向滚动位置快照
      search:{
        dateFrom:'',
        dateTo:'',
        ebsorderNo:'',
        poreference:'',
        orderStatus:'',
        shipTo:'',
        articleNumber:''
      },
      rules:{
        // dateFrom:[{required:true,trigger:'blur'}],
        // dateTo:[{required:true,trigger:'blur'}]
      },
      orderStatusText:'', //状态，用逗号隔开(搜索那边的状态)
      orderList:[], //列表数据
      orderStatusArr:[], //order status下拉数据
      shipToArr:[], //ship to下拉数据
      pickerOptions:{
        disabledDate: e => {
          let chooseDate = moment(new Date(e)).format('YYYY-MM-DD') //当选择的日期
          let chooseTime = new Date(chooseDate).valueOf() //选择的时间戳
          let date = moment(new Date()).format('YYYY-MM-DD') //当前日期
          let dateTime = new Date(date).valueOf() //当前日期时间戳
          //小于等于今天的时间，可以选择。反之不能选择
          if(chooseTime<=dateTime){
            return false
          }else{
            return true
          }
        }
      },//日期
      tableLable:{
        orderID:'',
        PONumber:'',
        orderDate:'',
        orderStatus:'',
        orderTotalAmount:'',
        placedVia:'',
        shipTo:'',
        taxTotalAmount:''
      } //表格的表头，因为这个地方切换语言的时候没办法正常渲染，所以需要监听语言包的变化，进行重新渲染
    }
  },
  computed:{
    showTotalAmount(){
      let flag1 = this.$store.state.userInfo.accountRules && this.$store.state.userInfo.accountRules.includes('SP')
      let flag2 = this.$store.state.userInfo.customerAccountNo
      return flag1 && flag2
    },
    showTotalAmountTax(){
      let flag1 = this.$store.state.userInfo.accountRules && this.$store.state.userInfo.accountRules.includes('SP')
      let flag2 = this.$store.state.userInfo.ledCustomerAccountNo
      return flag1 && flag2
    },
    accountRulesReady(){
      return !this.$cookies.get('token') || Array.isArray(this.$store.state.userInfo.accountRules)
    },
    tableReady(){
      return this.accountRulesReady && this.tableLable.orderID && this.tableLable.PONumber && this.tableLable.orderDate && this.tableLable.orderStatus && this.tableLable.placedVia && this.tableLable.shipTo && (!this.showTotalAmount || this.tableLable.orderTotalAmount) && (!this.showTotalAmountTax || this.tableLable.taxTotalAmount)
    }
  },
  watch:{
    L(newVal){
      this.syncTableLable(newVal)
    },
    /* 表格 v-if="tableReady" 异步成立后才渲染，此时再算高并绑滚动监听 */
    tableReady(val){
      if(val){
        this.$nextTick(()=>{
          this.handleResize()
          this.bindTableScroll()
        })
      }
    },
    showTotalAmount(){
      this.$nextTick(()=>{
        if(this.$refs.orderTable){
          this.$refs.orderTable.doLayout()
        }
      })
    },
    showTotalAmountTax(){
      this.$nextTick(()=>{
        if(this.$refs.orderTable){
          this.$refs.orderTable.doLayout()
        }
      })
    }
  },
  methods:{
    /* 计算并固定表格高度：以表格“实际渲染的顶部位置”为基准，视口高 − 表格顶 − 底部留白。
       顶部用实测(getBoundingClientRect)：吸顶头 .head-wrap 里 logo 是异步图片、昵称/菜单随 XHR 到位才渲染，
       mounted 时量会偏矮致表格过高。本页无分页条，表格直接铺到视口底部，仅底部留 16px 缓冲。
       头部高度会随异步数据继续变(XHR 不触发 window load)，故另用 observeHeadResize() 的 ResizeObserver 兜住。 */
    handleResize(){
      this.$nextTick(()=>{
        if(!this.$refs.orderTable){ return }
        let tableEl = this.$refs.orderTable.$el
        //表格顶部到文档顶部的实际距离(rect.top 是视口相对值，+pageYOffset 转为文档相对)
        let top = tableEl.getBoundingClientRect().top + window.pageYOffset
        //16 = 表格底部与视口底边之间保留的间距(缓冲)，确保横向滚动条完整可见
        let h = window.innerHeight - top - 16
        this.tableHeight = h > 200 ? h : 200
        this.$refs.orderTable.doLayout()
      })
    },
    /* 用 ResizeObserver 盯住吸顶头(.head-wrap)与按钮区(btnBox)：其高度会随 logo 图片、用户信息/权限菜单/语言包等
       异步数据到位而变，这些 XHR 不触发 window load，只靠 resize/load 会在头部最终长高前就定死表格高度。 */
    observeHeadResize(){
      if(typeof ResizeObserver === 'undefined'){ return }
      let targets = [document.querySelector('.head-wrap'), this.$refs.btnBox].filter(Boolean)
      if(!targets.length){ return }
      this.headResizeObserver = new ResizeObserver(()=>{ this.handleResize() })
      targets.forEach(el=>this.headResizeObserver.observe(el))
    },
    /* 绑定表格滚动监听：实时把 .el-table__body-wrapper 的横/纵滚动位置记到快照，供 keep-alive 返回时还原（幂等，避免重复绑定） */
    bindTableScroll(){
      let el = this.$refs.orderTable && this.$refs.orderTable.$el.querySelector('.el-table__body-wrapper')
      if(!el){ return }
      if(this.tableBodyEl === el){ return }
      if(this.tableBodyEl){ this.tableBodyEl.removeEventListener('scroll', this.handleTableScroll) }
      this.tableBodyEl = el
      this.tableBodyEl.addEventListener('scroll', this.handleTableScroll)
    },
    handleTableScroll(){
      if(this.tableBodyEl){
        this.savedScrollTop = this.tableBodyEl.scrollTop
        this.savedScrollLeft = this.tableBodyEl.scrollLeft
      }
    },
    /* 还原表格滚动位置：DOM 重新挂回后（$nextTick）把快照写回滚动容器。
       本页有 ResizeObserver→handleResize→doLayout 的算高逻辑，会在还原之后（同一帧的渲染阶段）重新把滚动重置到 0，
       故在 nextTick 之外再追加 requestAnimationFrame（连兜两帧）确保最终写回的快照生效。先把快照存到局部变量，
       避免 doLayout 重置触发的 scroll 事件把 savedScrollTop/Left 覆写为 0 后影响后续帧的还原。 */
    restoreTableScroll(){
      let top = this.savedScrollTop
      let left = this.savedScrollLeft
      let apply = ()=>{
        let bodyEl = this.$refs.orderTable && this.$refs.orderTable.$el.querySelector('.el-table__body-wrapper')
        if(bodyEl){
          bodyEl.scrollTop = top
          bodyEl.scrollLeft = left
        }
      }
      this.$nextTick(()=>{
        apply()
        requestAnimationFrame(()=>{
          apply()
          requestAnimationFrame(apply)
        })
      })
    },
    syncTableLable(newVal){
      if(!newVal || Array.isArray(newVal)){
        return
      }
      this.tableLable = {
        ...this.tableLable,
        ...newVal
      }
      this.$nextTick(()=>{
        if(this.$refs.orderTable){
          this.$refs.orderTable.doLayout()
        }
      })
    },
    orderDetailLink(obj){
      let link = `/#/orderDetail?ebsorderNo=${obj.ebsorderNo}`
      if(obj.orderBu){
        link += `&orderBu=${obj.orderBu}`
      }
      if(obj.relOrderDsNo){
        link += `&relOrderDsNo=${obj.relOrderDsNo}`
      }
      if(obj.relOrderLedNo){
        link += `&relOrderLedNo=${obj.relOrderLedNo}`
      }
      return link
    },
    mouseleave(flag){
      if(flag==1){
        this.show.showChoose=false
      }
    },
    /* 单击order status的下拉框，上面的 */
    clickChooseStatus(){
      this.show.showChoose=true
    },
    /* 选择下拉列表中的其中一项 */
    chooseStatus(item,i){
      //点击all的，如果是全选，或者全不选
      if(item.statusCode==0){
        let finalResult = !item.showTick
        this.orderStatusArr.forEach((val,i)=>{
          val.showTick=finalResult
          this.$set(this.orderStatusArr,i,val) //触发渲染
        })
      }else{
        //点击除了all之外的
        item.showTick=!item.showTick
        this.$set(this.orderStatusArr,i,item) //触发渲染
        let allFlag = true //标记是true，说明默认是全部都勾上的
        this.orderStatusArr.forEach((val)=>{
          //不是all的里面如果有一个是false,那all的那个选择就是false
          if(!val.showTick && val.statusCode!=0){
            allFlag=false
          }
        })
        //标记完成后，找到all的那个钩子，去勾上或者不勾上
        this.orderStatusArr.forEach((val,i3)=>{
          if(val.statusCode==0){
            val.showTick=allFlag
            this.$set(this.orderStatusArr,i3,val) //触发渲染
          }
        })
      }
      //无论哪种情况结束后，都需要重新设置orderStatusText和search.orderStatus
      let newOrderStatusText=[] //打钩的文字，排成数组
      let newOrderStatusCode=[] //打钩的id，排成数组
      this.orderStatusArr.forEach((val)=>{
        if(val.showTick){
          newOrderStatusText.push(val.statusValue)
          newOrderStatusCode.push(val.statusCode)
        }
      })
      this.orderStatusText=newOrderStatusText.join(',')
      this.search.orderStatus=newOrderStatusCode.join(',')
    },
    /*
      方法-传入需要选中的数组
      1.把下拉框的值自动勾选上
      2.把下拉框的input框自动填入
      3.把搜索orderStatus参数进行更正
    */
    setSelectStatus(arr){
      let chooseArr = arr
      let newOrderStatusText=[] //打钩的文字，排成数组
      let newOrderStatusCode=[] //打钩的id，排成数组
      this.orderStatusArr.forEach((val,i)=>{
        if(chooseArr.includes(val.statusCode)){
          val.showTick=true
          newOrderStatusText.push(val.statusValue)
          newOrderStatusCode.push(val.statusCode)
          this.$set(this.orderStatusArr,i,val) //触发渲染，把下拉框的值自动勾选上
        }else{
          val.showTick=false
        }
      })
      this.orderStatusText=newOrderStatusText.join(',') //把下拉框的input框自动填入
      this.search.orderStatus=newOrderStatusCode.join(',') //把搜索orderStatus参数进行更正
    },
    /* 获取订单列表 */
    getOrderList(){
      this.$refs.formSearch.validate(valid=>{
        if(!valid){
          this.$message.warning('Please enter the required search field.');
        }else{
          this.allLoading=true
          postAction(api_order_list,this.search).then(res=>{
            this.allLoading=false
            this.orderList=res.header
            this.setSelectStatus(res.status)
            this.$nextTick(()=>{
              if(this.$refs.orderTable){
                this.$refs.orderTable.doLayout()
              }
            })
          }).catch(()=>{
            this.allLoading=false
          })
        }
      })
    },
    /* 下载列表 */
    downloadList(){
      this.allLoading=true
      downFilePost(api_order_list_download,this.search).then(res=>{
        this.allLoading=false
        this.downloadFile(res)
      }).catch(()=>{
        this.allLoading=false
      })
    },
    downloadListLed(){
      this.allLoading=true
      downFilePost(api_order_list_download_LED,this.search).then(res=>{
        this.allLoading=false
        this.downloadFile(res)
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 下载详情 */
    downloadDetail(){
      this.allLoading=true
      downFilePost(api_order_list_detail_download,this.search).then(res=>{
        this.allLoading=false
        this.downloadFile(res)
      }).catch(()=>{
        this.allLoading=false
      })
    },
    downloadDetailLed(){
      this.allLoading=true
      downFilePost(api_order_list_detail_download_LED,this.search).then(res=>{
        this.allLoading=false
        this.downloadFile(res)
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 重置搜索条件并且直接请求数据 */
    clearFilters(){
      this.search={
        dateFrom:'',
        dateTo:'',
        ebsorderNo:'',
        poreference:'',
        orderStatus:'',
        shipTo:'',
        articleNumber:''
      }
      //清空order status的数据和下拉框的打钩
      this.orderStatusText=''
      this.orderStatusArr.forEach((val,i)=>{
        this.orderStatusArr[i].showTick=false
      })
      this.setDefaultDate()
    },
    handleClearFilters(){
      this.clearFilters()
      this.getOrderList()
    },
    /* 设置默认日期,进到这个路由的时候要设置一下默认日期 */
    setDefaultDate(){
      let date = new Date()
      this.search.dateTo = moment(date).format('YYYY-MM-DD')
      this.search.dateFrom = moment(date).subtract(3,'months').format('YYYY-MM-DD') //回退3个月
    },
    /* 获取order status和ship to的下拉数据 */
    getSelectData(){
      postAction(api_order_select_data).then(res=>{
        this.orderStatusArr=res.mixStatus.allOrderStatusList
        // this.orderStatusArr.unshift({
        //   showTick:false,
        //   statusCode:0,
        //   statusValue:this.L.all
        // })
        this.shipToArr=res.shipToList
        this.search.orderStatus=''
        this.search.shipTo='ALL'
      })
    },
    /* 从后端拿新的列表数据 */
    showOpenOrders(){
      this.clearFilters()
      this.search.dateFrom=''
      this.search.dateTo=''
      //自动勾选4,5,7,8,9
      let chooseArr = [4,5,7,8,9]
      this.setSelectStatus(chooseArr)
      this.getOrderList()
    }
  },
  mounted(){
    this.syncTableLable(this.L)
    this.setDefaultDate() //注意这个方法要在getOrderList之前，因为在最开始加载请求的时候，需要先把日期设置进去并且传给后端再去请求数据
    this.getSelectData()
    this.getOrderList()
    //表格铺满视口剩余高度并内部滚动：算高 + 监听 resize/load + ResizeObserver 兜住头部异步变高
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('load', this.handleResize)
    this.observeHeadResize()
    this.$nextTick(()=>{ this.bindTableScroll() })
  },
  activated(){
    //从顶部导航栏进入时，重新初始化页面状态
    if(this.$route.query.from === 'top'){
      this.syncTableLable(this.L)
      this.paginationObj.currentPage = 1
      this.clearFilters()
      let chooseArr = [4,5,7,8,9]
      this.setSelectStatus(chooseArr)
      this.getOrderList()
      setTimeout(()=>{
        window.scrollTo(0, 0)
      }, 50)
    }else{
      //从面包屑返回时，还原表格内部滚动位置（文档已不滚动，改为表格 body-wrapper 内部滚动）
      this.restoreTableScroll()
    }
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('load', this.handleResize)
    if(this.tableBodyEl){
      this.tableBodyEl.removeEventListener('scroll', this.handleTableScroll)
      this.tableBodyEl = null
    }
    if(this.headResizeObserver){
      this.headResizeObserver.disconnect()
      this.headResizeObserver = null
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../../public/css/public.less');
@import url('./index.less');
</style>

